// ── 반지 상자 데이터 ──────────────────────────────────
// 출처: https://matsu1207.tistory.com/144 (2026-04-18 기준)
// 아이콘 URL 추가 시 boxIcon, icon 필드에 입력하세요.
// levelProb: null = 해당 레벨 없음

export const RING_BOX_DATA = [
  {
    key: "green",
    name: "녹옥의 보스 반지 상자",
    boxIcon: "",  // 추후 입력
    dropBosses: ["스우(노멀)", "데미안(노멀)", "가디언 엔젤 슬라임(노멀)", "루시드(이지/노멀)", "윌(이지/노멀)", "더스크(노멀)", "듄켈(노멀)"],
    levelProb: { "1": 50.0, "2": 41.0, "3": 9.0, "4": null },
    rings: [
      { name: "리스트레인트 링", prob: 2.11268, icon: "" },
      { name: "컨티뉴어스 링", prob: 2.11268, icon: "" },
      { name: "웨폰퍼프-S링", prob: 2.8169, icon: "" },
      { name: "웨폰퍼프-D링", prob: 2.8169, icon: "" },
      { name: "웨폰퍼프-I링", prob: 2.8169, icon: "" },
      { name: "웨폰퍼프-L링", prob: 2.8169, icon: "" },
      { name: "얼티메이덤 링", prob: 2.8169, icon: "" },
      { name: "리스크테이커 링", prob: 2.8169, icon: "" },
      { name: "링 오브 썸", prob: 2.8169, icon: "" },
      { name: "크리데미지 링", prob: 2.8169, icon: "" },
      { name: "크라이시스-HM링", prob: 2.8169, icon: "" },
      { name: "버든리프트 링", prob: 3.52113, icon: "" },
      { name: "오버패스 링", prob: 3.52113, icon: "" },
      { name: "레벨퍼프-S링", prob: 3.52113, icon: "" },
      { name: "레벨퍼프-D링", prob: 3.52113, icon: "" },
      { name: "레벨퍼프-I링", prob: 3.52113, icon: "" },
      { name: "레벨퍼프-L링", prob: 3.52113, icon: "" },
      { name: "헬스컷 링", prob: 3.52113, icon: "" },
      { name: "크리디펜스 링", prob: 3.52113, icon: "" },
      { name: "리밋 링", prob: 3.52113, icon: "" },
      { name: "듀라빌리티 링", prob: 3.52113, icon: "" },
      { name: "리커버디펜스 링", prob: 3.52113, icon: "" },
      { name: "실드스와프 링", prob: 3.52113, icon: "" },
      { name: "마나컷 링", prob: 3.52113, icon: "" },
      { name: "크라이시스-H링", prob: 3.52113, icon: "" },
      { name: "크라이시스-M링", prob: 3.52113, icon: "" },
      { name: "크리쉬프트 링", prob: 3.52113, icon: "" },
      { name: "스탠스쉬프트 링", prob: 3.52113, icon: "" },
      { name: "리커버스탠스 링", prob: 3.52113, icon: "" },
      { name: "스위프트 링", prob: 3.52113, icon: "" },
      { name: "리플렉티브 링", prob: 3.52113, icon: "" },
    ],
  },
  {
    key: "red",
    name: "홍옥의 보스 반지 상자",
    boxIcon: "",  // 추후 입력
    dropBosses: ["스우(하드)", "데미안(하드)", "루시드(하드)", "윌(하드)", "진 힐라(노멀)"],
    levelProb: { "1": 40.0, "2": 30.0, "3": 20.0, "4": 10.0 },
    rings: [
      { name: "리스트레인트 링", prob: 6.92308, icon: "" },
      { name: "컨티뉴어스 링", prob: 6.92308, icon: "" },
      { name: "웨폰퍼프-S링", prob: 6.15385, icon: "" },
      { name: "웨폰퍼프-D링", prob: 6.15385, icon: "" },
      { name: "웨폰퍼프-I링", prob: 6.15385, icon: "" },
      { name: "웨폰퍼프-L링", prob: 6.15385, icon: "" },
      { name: "얼티메이덤 링", prob: 6.15385, icon: "" },
      { name: "리스크테이커 링", prob: 6.15385, icon: "" },
      { name: "링 오브 썸", prob: 6.15385, icon: "" },
      { name: "크리데미지 링", prob: 6.15385, icon: "" },
      { name: "크라이시스-HM링", prob: 6.15385, icon: "" },
      { name: "버든리프트 링", prob: 1.53846, icon: "" },
      { name: "오버패스 링", prob: 1.53846, icon: "" },
      { name: "레벨퍼프-S링", prob: 1.53846, icon: "" },
      { name: "레벨퍼프-D링", prob: 1.53846, icon: "" },
      { name: "레벨퍼프-I링", prob: 1.53846, icon: "" },
      { name: "레벨퍼프-L링", prob: 1.53846, icon: "" },
      { name: "헬스컷 링", prob: 1.53846, icon: "" },
      { name: "크리디펜스 링", prob: 1.53846, icon: "" },
      { name: "리밋 링", prob: 1.53846, icon: "" },
      { name: "듀라빌리티 링", prob: 1.53846, icon: "" },
      { name: "리커버디펜스 링", prob: 1.53846, icon: "" },
      { name: "실드스와프 링", prob: 1.53846, icon: "" },
      { name: "마나컷 링", prob: 1.53846, icon: "" },
      { name: "크라이시스-H링", prob: 1.53846, icon: "" },
      { name: "크라이시스-M링", prob: 1.53846, icon: "" },
      { name: "크리쉬프트 링", prob: 1.53846, icon: "" },
      { name: "스탠스쉬프트 링", prob: 1.53846, icon: "" },
      { name: "리커버스탠스 링", prob: 1.53846, icon: "" },
      { name: "스위프트 링", prob: 1.53846, icon: "" },
      { name: "리플렉티브 링", prob: 1.53846, icon: "" },
    ],
  },
  {
    key: "black",
    name: "흑옥의 보스 반지 상자",
    boxIcon: "",  // 추후 입력
    dropBosses: ["더스크(카오스)", "듄켈(하드)", "가디언 엔젤 슬라임(카오스)", "진 힐라(하드)", "선택받은 세렌(노멀)"],
    levelProb: { "1": 25.0, "2": 25.0, "3": 30.0, "4": 20.0 },
    rings: [
      { name: "리스트레인트 링", prob: 12.5, icon: "" },
      { name: "컨티뉴어스 링", prob: 12.5, icon: "" },
      { name: "웨폰퍼프-S링", prob: 8.33333, icon: "" },
      { name: "웨폰퍼프-D링", prob: 8.33333, icon: "" },
      { name: "웨폰퍼프-I링", prob: 8.33333, icon: "" },
      { name: "웨폰퍼프-L링", prob: 8.33333, icon: "" },
      { name: "얼티메이덤 링", prob: 8.33333, icon: "" },
      { name: "리스크테이커 링", prob: 8.33333, icon: "" },
      { name: "링 오브 썸", prob: 8.33333, icon: "" },
      { name: "크리데미지 링", prob: 8.33333, icon: "" },
      { name: "크라이시스-HM링", prob: 8.33333, icon: "" },
    ],
  },
  {
    key: "white",
    name: "백옥의 보스 반지 상자",
    boxIcon: "",  // 추후 입력
    dropBosses: ["스우(익스트림)", "검은 마법사(하드/익스트림)", "선택받은 세렌(하드/익스트림)", "감시자 칼로스(이지/노멀)", "카링(이지/노멀)", "최초의 대적자(이지/노멀)", "찬란한 흉성(노멀)"],
    levelProb: { "1": null, "2": null, "3": 65.0, "4": 35.0 },
    rings: [
      { name: "리스트레인트 링", prob: 14.28571, icon: "" },
      { name: "컨티뉴어스 링", prob: 14.28571, icon: "" },
      { name: "웨폰퍼프-S링", prob: 7.93651, icon: "" },
      { name: "웨폰퍼프-D링", prob: 7.93651, icon: "" },
      { name: "웨폰퍼프-I링", prob: 7.93651, icon: "" },
      { name: "웨폰퍼프-L링", prob: 7.93651, icon: "" },
      { name: "얼티메이덤 링", prob: 7.93651, icon: "" },
      { name: "리스크테이커 링", prob: 7.93651, icon: "" },
      { name: "링 오브 썸", prob: 7.93651, icon: "" },
      { name: "크리데미지 링", prob: 7.93651, icon: "" },
      { name: "크라이시스-HM링", prob: 7.93651, icon: "" },
    ],
  },
  {
    key: "life",
    name: "생명의 보스 반지 상자",
    boxIcon: "",  // 추후 입력
    dropBosses: ["감시자 칼로스(카오스/익스트림)", "카링(하드/익스트림)", "림보(노멀/하드)", "발드릭스(노멀/하드)", "최초의 대적자(하드/익스트림)", "찬란한 흉성(하드)", "유피테르(노멀/하드)"],
    levelProb: { "1": null, "2": null, "3": 30.0, "4": 70.0 },
    rings: [
      { name: "리스트레인트 링", prob: 14.51613, icon: "" },
      { name: "컨티뉴어스 링", prob: 14.51613, icon: "" },
      { name: "웨폰퍼프-S링", prob: 8.06452, icon: "" },
      { name: "웨폰퍼프-D링", prob: 8.06452, icon: "" },
      { name: "웨폰퍼프-I링", prob: 8.06452, icon: "" },
      { name: "웨폰퍼프-L링", prob: 8.06452, icon: "" },
      { name: "얼티메이덤 링", prob: 8.06452, icon: "" },
      { name: "리스크테이커 링", prob: 8.06452, icon: "" },
      { name: "링 오브 썸", prob: 8.06452, icon: "" },
      { name: "크리데미지 링", prob: 8.06452, icon: "" },
      { name: "크라이시스-HM링", prob: 8.06452, icon: "" },
      { name: "버든리프트 링", prob: 1.6129, icon: "" },
      { name: "오버패스 링", prob: 1.6129, icon: "" },
      { name: "레벨퍼프-S링", prob: 1.6129, icon: "" },
      { name: "레벨퍼프-D링", prob: 1.6129, icon: "" },
      { name: "레벨퍼프-I링", prob: 1.6129, icon: "" },
      { name: "레벨퍼프-L링", prob: 1.6129, icon: "" },
      { name: "헬스컷 링", prob: 1.6129, icon: "" },
      { name: "크리디펜스 링", prob: 1.6129, icon: "" },
      { name: "리밋 링", prob: 1.6129, icon: "" },
      { name: "듀라빌리티 링", prob: 1.6129, icon: "" },
      { name: "리커버디펜스 링", prob: 1.6129, icon: "" },
      { name: "실드스와프 링", prob: 1.6129, icon: "" },
      { name: "마나컷 링", prob: 1.6129, icon: "" },
      { name: "크라이시스-H링", prob: 1.6129, icon: "" },
      { name: "크라이시스-M링", prob: 1.6129, icon: "" },
      { name: "크리쉬프트 링", prob: 1.6129, icon: "" },
      { name: "스탠스쉬프트 링", prob: 1.6129, icon: "" },
      { name: "리커버스탠스 링", prob: 1.6129, icon: "" },
      { name: "스위프트 링", prob: 1.6129, icon: "" },
      { name: "리플렉티브 링", prob: 1.6129, icon: "" },
    ],
  },
];

/**
 * 반지 상자 이름으로 데이터 반환
 * @param {string} boxName
 */
export function getRingBoxData(boxName) {
  return RING_BOX_DATA.find(b => b.name === boxName) || null;
}

/**
 * 획득한 반지 상자에서 레벨과 링 종류를 선택했을 때 기록용 객체 반환
 * @param {string} boxKey  - 'green' | 'red' | 'black' | 'white' | 'life'
 * @param {string} level   - '1' | '2' | '3' | '4'
 * @param {string} ringName
 */
export function makeRingRecord(boxKey, level, ringName) {
  const box = RING_BOX_DATA.find(b => b.key === boxKey);
  if (!box) return null;
  const ring = box.rings.find(r => r.name === ringName);
  return {
    boxKey,
    boxName: box.name,
    level,
    ringName,
    ringIcon: ring?.icon || "",
    prob: ring?.prob || 0,
  };
}